
    import {Component, Prop, Vue} from "vue-property-decorator";
    import {mapActions, mapGetters} from "vuex";
    import {UserLocation} from "@/shared/services/UserLocation";

    @Component({
        name: 'favorite',
        computed: {
            ...mapGetters(['favorite'])
        },
        methods: {
            ...mapActions(['setFavorite'])
        }
    })
    export default class Favorite extends Vue {
        @Prop({default: true}) identifier!: string;
        @Prop({default: false}) disabled!: boolean;
        @Prop({default: ''}) city!: string;
        private readonly WINDOW_EVENT: string = 'FavoriteChanged';
        private favorite!: string;
        private setFavorite!: (identifier: string | null) => void;

        get active() {
            return this.favorite === this.identifier;
        }

        mounted() {
            window.addEventListener(this.WINDOW_EVENT, () => {
                if (this.favorite === UserLocation.get()) return;
                if (!UserLocation.has()) return this.setFavorite(null);
                return this.setFavorite(UserLocation.get());
            })
        }

        activate(identifier: string) {
            if(this.disabled) return;
            this.setFavorite(identifier);
            UserLocation.set(identifier, this.city);
        }

        deactivate() {
            if(this.disabled) return;
            this.setFavorite(null);
            UserLocation.remove();
        }
    }
